export const LOGIN_ROUTE = '/login';

export const MAIN_ROUTE = '/';
export const CATALOG_ROUTE = '/catalog';
export const SEARCH_ROUTE = '/search-request';
export const ITEM_ROUTE = '/product';
export const ADMIN_ROUTE = '/admin';
export const CONTACTS_ROUTE = '/contacts';
export const ABOUT_ROUTE = '/abaut';